import { CheckCircle2 } from 'lucide-react';
import Reveal from './Reveal';

const ABOUT_BG =
  'https://images.pexels.com/photos/3678228/pexels-photo-3678228.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940';

const STATS = [
  { value: '2017', label: 'Fundação da empresa' },
  { value: '+7', label: 'Anos de experiência' },
  { value: '05', label: 'Linhas de produtos' },
  { value: '04', label: 'Níveis de treinamento' },
];

const VALUES = [
  'Qualidade e excelência',
  'Compromisso com o cliente',
  'Profissionalismo',
  'Inovação constante',
];

const About = () => (
  <section id="sobre" data-testid="about-section" className="relative py-28 bg-[#040D1A] overflow-hidden">
    <div className="absolute inset-0 pointer-events-none">
      <img src={ABOUT_BG} alt="" aria-hidden="true" className="w-full h-full object-cover opacity-[0.07]" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#040D1A] via-transparent to-[#040D1A]" />
    </div>

    <div className="container mx-auto px-4 relative z-10 grid lg:grid-cols-2 gap-16 items-center">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-amber-300 mb-4">
          Sobre Nós
        </p>
        <h2 className="font-display font-extrabold uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
          Quem apaga o fogo{' '}
          <span className="text-amber-400 italic">antes</span> que ele comece
        </h2>
        <div className="mt-8 space-y-5 text-slate-300 leading-relaxed text-sm sm:text-base">
          <p>
            A <span className="text-white font-semibold">Leão de Fogo</span> atua desde{' '}
            <span className="text-amber-400 font-semibold">2017</span> no mercado de prevenção e
            combate a incêndios, consolidando-se como referência em qualidade e excelência na região.
          </p>
          <p>
            Nossa missão é fornecer soluções completas em segurança contra incêndios — de
            equipamentos certificados a projetos especializados e treinamentos profissionais —
            garantindo proteção e tranquilidade aos nossos clientes.
          </p>
        </div>
        <ul className="mt-8 grid sm:grid-cols-2 gap-3">
          {VALUES.map((value) => (
            <li key={value} className="flex items-center gap-2 text-sm text-slate-200">
              <CheckCircle2 className="w-4 h-4 text-amber-400 shrink-0" />
              {value}
            </li>
          ))}
        </ul>
      </Reveal>

      <div className="grid grid-cols-2 gap-5">
        {STATS.map((stat, i) => (
          <Reveal key={stat.label} delay={i * 0.1} className="h-full">
            <div
              data-testid={`about-stat-${i}`}
              className="h-full rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur-sm p-7 text-center hover:border-amber-400/40 hover:-translate-y-1 transition-all duration-500"
            >
              <p className="font-display font-extrabold text-4xl sm:text-5xl text-amber-400">
                {stat.value}
              </p>
              <p className="mt-2 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400">
                {stat.label}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default About;
